import { useQuery } from "@tanstack/react-query";

import { ApiClient } from "../api-client";

/**
 * Courses open for pre-inscription (unpublished, flagged `preinscriptionOpen`),
 * served by GET /api/course-preinscriptions/open (@Public; `isPreinscribed` is
 * resolved per-user when the auth cookie is present).
 */
export type OpenPreinscriptionCourse = {
  id: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  priceInCents: number;
  mercadopagoPriceInCents: number;
  mercadopagoProductId: string | null;
  currency: string;
  isPreinscribed: boolean;
  preinscribedCount: number;
};

export const openPreinscriptionCoursesQueryKey = ["open-preinscription-courses"];

export function useOpenPreinscriptionCourses() {
  return useQuery<OpenPreinscriptionCourse[]>({
    queryKey: openPreinscriptionCoursesQueryKey,
    queryFn: async () => {
      const res = await ApiClient.instance.get("/api/course-preinscriptions/open");
      return (res.data?.data ?? []) as OpenPreinscriptionCourse[];
    },
    staleTime: 60_000,
  });
}
